/* @flow */

import React from "react";

import AmexLogo from "icons/payment_methods/amex.svg";
import MastercardLogo from "icons/payment_methods/mastercard.svg";
import VisaLogo from "icons/payment_methods/visa.svg";

import styles from "./styles.scss";

const PaymentMethodsCards = (): React$Node => {
  return (
    <div className={styles.cards}>
      <div className={styles.cardsInner}>
        <div><MastercardLogo className={styles.mastercard} /></div>
        <div><VisaLogo className={styles.visa} /></div>
        <div><AmexLogo className={styles.amex} /></div>
      </div>
    </div>
  );
};

export default PaymentMethodsCards;
